import { render } from "./EditSvg.vue?vue&type=template&id=3f9f278a"
import script from "./EditSvg.vue?vue&type=script&lang=js"
export * from "./EditSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__